import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';

const useStyles = makeStyles(({ palette }: Theme) => createStyles({
  buttonPurchaseContained: {
    color: '#FFF',
    background: palette.buttonSingle.color,
    '&:hover': {
      backgroundColor: palette.buttonSingle.color,
    },
  },
  buttonPurchaseOutlined: {
    color: palette.buttonSingle.color,
    borderColor: palette.buttonSingle.color,
  },
  buttonLink: {
    '&:hover': {
      textDecoration: 'none',
    },
  },
  button: {
    height: '32px',
    maxWidth: '134px',
    width: '100%',
    whiteSpace: 'nowrap',
    textTransform: 'none',
    fontSize: 14,
    fontFamily: 'Montserrat, sans',
    fontWeight: 600,
    padding: '5px 20px',
    boxShadow: 'none',
    letterSpacing: '0.21px',
  },
  buttonLabel: {
    padding: 'none',
    fontSize: 14,
  },

}), { name: 'EditOrder' });

export default useStyles;
